/*
 * 旧「Buy it now 清空购物车再恢复」逻辑的收尾（10/23 重写）。
 * 新版 buy-now-with-gift.js 不再清空购物车、不再往 localStorage 存东西，所以这里不再清空购物车。
 * 只处理旧版遗留：浏览器里还留着 Feppo_saved_cart（72 小时内）时——
 *   - 当前购物车是空的：一次性把旧商品加回去（不调用 clear）；
 *   - 当前购物车有东西：不动购物车，直接丢弃旧记录。
 * 72 小时后所有遗留记录都会过期，这个文件可以整个删掉（同时删 theme.liquid 里对它的引用）。
 */
class CartRestore {
  constructor() {
    this.STORAGE_KEY = "Feppo_saved_cart";
    this.TIMESTAMP_KEY = "Feppo_saved_cart_time";
    this.EXPIRY_HOURS = 72;
    this.init();
  }

  getRouteRoot() {
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const themeRoot = window.theme && window.theme.routes && window.theme.routes.root_url;
    const root = shopifyRoot || themeRoot || "/";
    return root.endsWith("/") ? root : `${root}/`;
  }

  getCartEndpoint(path) {
    return this.getRouteRoot() + path.replace(/^\//, "");
  }

  clearSavedCart() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
      localStorage.removeItem(this.TIMESTAMP_KEY);
    } catch (e) {}
  }

  async init() {
    let raw = null;
    try {
      raw = localStorage.getItem(this.STORAGE_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    const path = window.location.pathname;
    if (path.includes("/checkout") || path.includes("/thank_you") || path.includes("/orders/")) return;

    let items = null;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      this.clearSavedCart();
      return;
    }
    const ts = parseInt(localStorage.getItem(this.TIMESTAMP_KEY));
    const expired = !ts || (Date.now() - ts) / 36e5 > this.EXPIRY_HOURS;
    if (!items || !items.length || expired) {
      this.clearSavedCart();
      return;
    }

    try {
      const cart = await (await fetch(this.getCartEndpoint("cart.js"), { cache: "no-store" })).json();
      if (cart.item_count === 0) {
        const lines = items
          .filter((item) => item.variant_id)
          .map((item) => ({ id: item.variant_id, quantity: item.quantity, properties: item.properties || {} }));
        if (lines.length) {
          await fetch(this.getCartEndpoint("cart/add.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: lines })
          });
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          if (window.dispatchEvent) window.dispatchEvent(new CustomEvent("cart:updated"));
        }
      }
    } catch (e) {
      console.warn("[Cart Restore] skipped:", e);
    } finally {
      this.clearSavedCart();
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new CartRestore();
  });
} else {
  new CartRestore();
}
